import React from "react";
import { PrepaidCardEditor } from "../features/prepaid-cards";
import { withRestaurantId } from "../shared/components/layout";

const PrepaidCardEditorWithId = withRestaurantId(PrepaidCardEditor);

const PrepaidCardsPage: React.FC = () => {
  return <PrepaidCardEditorWithId />;
};

export default PrepaidCardsPage;
